/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the Excel compatibility workflow`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看 Excel 兼容性验证流程`)
};

/**
* | output |
* | --- |
* | "Check the Excel compatibility workflow" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Links_1_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_2_links_1_label as "gc.search_guides.gridcraft_vs_excel.sections.2.links.1.label" }